export const wandbModels = {
    id: "wandb",
    name: "Weights & Biases",
    api: "https://api.inference.wandb.ai/v1",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://weave-docs.wandb.ai/guides/integrations/inference/",
    env: ["WANDB_API_KEY"],
    models: {
        "deepseek-ai/DeepSeek-V3-0324": {
            id: "deepseek-ai/DeepSeek-V3-0324",
            name: "DeepSeek-V3-0324",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-03-24",
            last_updated: "2025-03-24",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.14,
                output: 2.75,
            },
            limit: {
                context: 161000,
                output: 8192,
            },
        },
        "deepseek-ai/DeepSeek-R1-0528": {
            id: "deepseek-ai/DeepSeek-R1-0528",
            name: "DeepSeek-R1-0528",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-05",
            release_date: "2025-05-28",
            last_updated: "2025-05-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.35,
                output: 5.4,
            },
            limit: {
                context: 161000,
                output: 163840,
            },
        },
        "Qwen/Qwen3-Coder-480B-A35B-Instruct": {
            id: "Qwen/Qwen3-Coder-480B-A35B-Instruct",
            name: "Qwen3-Coder-480B-A35B-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-23",
            last_updated: "2025-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1,
                output: 1.5,
            },
            limit: {
                context: 262144,
                output: 66536,
            },
        },
        "Qwen/Qwen3-235B-A22B-Thinking-2507": {
            id: "Qwen/Qwen3-235B-A22B-Thinking-2507",
            name: "Qwen3-235B-A22B-Thinking-2507",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-25",
            last_updated: "2025-07-25",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "Qwen/Qwen3-235B-A22B-Instruct-2507": {
            id: "Qwen/Qwen3-235B-A22B-Instruct-2507",
            name: "Qwen3 235B A22B Instruct 2507",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-04-28",
            last_updated: "2025-07-21",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.1,
                output: 0.1,
            },
            limit: {
                context: 262144,
                output: 131072,
            },
        },
        "meta-llama/Llama-4-Scout-17B-16E-Instruct": {
            id: "meta-llama/Llama-4-Scout-17B-16E-Instruct",
            name: "Llama 4 Scout 17B 16E Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-12",
            release_date: "2025-01-31",
            last_updated: "2025-01-31",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.17,
                output: 0.66,
            },
            limit: {
                context: 64000,
                output: 8192,
            },
        },
        "meta-llama/Llama-3.3-70B-Instruct": {
            id: "meta-llama/Llama-3.3-70B-Instruct",
            name: "Llama-3.3-70B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-12-06",
            last_updated: "2024-12-06",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.71,
                output: 0.71,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "meta-llama/Llama-3.1-8B-Instruct": {
            id: "meta-llama/Llama-3.1-8B-Instruct",
            name: "Meta-Llama-3.1-8B-Instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-12",
            release_date: "2024-07-23",
            last_updated: "2024-07-23",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.22,
                output: 0.22,
            },
            limit: {
                context: 128000,
                output: 32768,
            },
        },
        "microsoft/Phi-4-mini-instruct": {
            id: "microsoft/Phi-4-mini-instruct",
            name: "Phi-4-mini-instruct",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2023-10",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.08,
                output: 0.35,
            },
            limit: {
                context: 128000,
                output: 4096,
            },
        },
        "moonshotai/Kimi-K2-Instruct": {
            id: "moonshotai/Kimi-K2-Instruct",
            name: "Kimi-K2-Instruct",
            attachment: false,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-07-14",
            last_updated: "2025-07-14",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 1.35,
                output: 4,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
    },
};
export default wandbModels;
//# sourceMappingURL=wandb.js.map